module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAABHNCSVQICAgIfAhkiAAAAUNJREFUOE/FlbFPwkAUxr9XBNMFTUiEwa4sLqywGIOLiSaGQVb/A03cje4srv4JDpiIiYyVAQZdWRhcWDpAIl2A9tpnrkon21LbxBsv7373vXvfvUcAsOzsnDLoAswVEG3LvZhLZzi36slEpx/YY0zAr+EM54DmT0WdCPthQFI1KNoZ3PEDeD4ODGXGKy06RY6C5epv3yH2DFbvMBjK/BkJVAo1ZKtt/0570IA77Qdq+H+g1auDzeHfFcqC+G8oLfZcCjVEZMry9Oax4UPSBQoTy245BYXSNqoGnvZhDRrJgblqG1SopQ90jS7s9/PkCrOVOyi7TTijFsSolRyIjTwypSM4xgsgzORA+f0y5SuI4XWoqeVNa/lwVZTIlJln67Wv/J6Xsvi4D03Za1+pN9jVCHCZLgneCNiK272lMpBzI0fAF8wEs3zI+EuDAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/Assets/img/iconplanwarn.png
// module id = 1016
// module chunks = 0